
















import { Component, Vue } from 'vue-property-decorator'
import CommonTopicHeader from '@/components/Group/CommonTopicHeader.vue'
import NavMenuBar from '@/components/NavMenuBar.vue'
import { fetchCommonTopicEditRole } from '@/helpers/fetchCommonTopicEditRole'

@Component({ components: { CommonTopicHeader, NavMenuBar } })
export default class LayoutCommonTopic extends Vue {
  async created() {
    await fetchCommonTopicEditRole()
  }
}
